import { X } from 'lucide-react';
import { Button } from '../ui/button';
import { Tooltip } from '../ui/tooltip';

interface ChipProps {
  fileName: string;
  fileSize: string;
  onRemove: () => void;
}

const Chip = ({ fileName, fileSize, onRemove }: ChipProps) => {
  const getTruncatedName = (name: string, maxLength: number = 15) => {
    if (name.length <= maxLength) return name;
    return name.substring(0, maxLength - 3) + '...';
  };

  return (
    <Tooltip
      align="left"
      content={
        <div className="flex flex-col items-center gap-2">
          <span className="font-medium text-xs">
            {fileName} {fileSize}
          </span>
        </div>
      }
    >
      <div className="inline-flex items-center gap-1.5 bg-green-100 hover:bg-green-200 border border-gray-300 rounded-full px-2 py-2 max-w-[140px]">
        <span className="text-xs font-medium text-gray-700 truncate flex-1 min-w-0">
          {getTruncatedName(fileName)}
        </span>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          onClick={onRemove}
          className="h-3 w-3 p-0 text-gray-500 hover:text-red-600 flex-shrink-0"
        >
          <X className="h-4 w-4 text-red-500" />
        </Button>
      </div>
    </Tooltip>
  );
};

export default Chip;
